import {
  SEARCH_RESULTS_MAX,
  SEARCH_RESULTS_MAX_MD,
  SEARCH_RESULTS_MAX_NARROW,
} from "@/lib/constants/search";

/** Tailwind `sm` — matches `grid-cols-3` start. */
export const HEADER_SEARCH_MIN_WIDTH_SM = "(min-width: 640px)";

/** Tailwind `md` — four-column grid. */
export const HEADER_SEARCH_MIN_WIDTH_MD = "(min-width: 768px)";

/** Tailwind `lg` — five-column grid. */
export const HEADER_SEARCH_MIN_WIDTH_LG = "(min-width: 1024px)";

/**
 * Caps ranked hits to align with the responsive grid (3 / 4 / 5 columns).
 * lg+: 10 (two rows of five), md..lg-1: 8 (two rows of four), sm..md-1: 10, below sm: 9.
 */
export function headerSearchResultsCap(isSm: boolean, isMd: boolean, isLg: boolean): number {
  if (isLg) return SEARCH_RESULTS_MAX;
  if (isMd) return SEARCH_RESULTS_MAX_MD;
  if (isSm) return SEARCH_RESULTS_MAX;
  return SEARCH_RESULTS_MAX_NARROW;
}
